export default {"src":"/_next/static/media/dteLogo.0930c6e0.svg","height":32,"width":93,"blurWidth":0,"blurHeight":0};